import styles from '../InternalExternalDetail.module.css'

const SkillsBlock = ({ skills, chipVariant = 'chipBlue' }) => (
  <div className={styles.skillBlock}>
    <div className={styles.skillTitle}>Skills</div>
    <div className={styles.chipRow}>
      {skills.map((skill) => (
        <span key={skill} className={styles[chipVariant]}>
          {skill}
        </span>
      ))}
    </div>
  </div>
)

export default SkillsBlock
